import { useState, useRef, useCallback } from 'react'

const usePageLayout = () => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const statusCardRef = useRef<HTMLDivElement>(null)
  const remarkCardRef = useRef<HTMLDivElement>(null)
  return {
    wrapperRef,
    statusCardRef,
    remarkCardRef,
  }
}

export default usePageLayout
